import { SVGProps } from "react";

export default function Tick(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 28" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.8743 0.21967C39.1671 0.512563 39.1671 0.987437 38.8743 1.28033L13.279 26.8756C13.2725 26.8821 13.2658 26.8885 13.259 26.8948C13.2531 26.9012 13.247 26.9075 13.2407 26.9138C12.9478 27.2067 12.473 27.2067 12.1801 26.9138L0.21967 14.9534C-0.0732233 14.6605 -0.0732233 14.1856 0.21967 13.8927C0.512563 13.5998 0.987437 13.5998 1.28033 13.8927L12.7104 25.3228L37.8136 0.21967C38.1065 -0.0732233 38.5814 -0.0732233 38.8743 0.21967Z"
        fill="currentColor"
      />
    </svg>
  );
}
